/* import __COLOCATED_TEMPLATE__ from './credit-card-apply.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();